export const Courses = [
    {
        id: 1,
        title:"On-boarding",
        progress:20
    },
    {
        id: 2,
        title:"Eddify",
        progress:30

    }
]
export const SampleCourses = [
    {
        id: 1,
        title:"On-boarding",
        progress:20
    },
    {
        id: 2,
        title:"Eddify",
        progress:30

    },
    {
        id: 3,
        title:"On-boarding",
        progress:20
    },
    {
        id: 4,
        title:"Eddify",
        progress:30

    }
]
